module.exports = __webpack_public_path__ + "media/v2/components/shared/Image/contest_stats/mlb/survive/hits-rbis-1-5009779b49db90b42a71f45bdd8f52a7.svg";